import * as yup from 'yup';

export const ShiftSchema = yup.object({
  early: yup.date().notRequired().nullable().default(undefined),
  late: yup.date().notRequired().nullable().default(undefined),
  night: yup.date().notRequired().nullable().default(undefined),
});

export type IShift = {
  early?: Date;
  late?: Date;
  night?: Date;
};
